import React from "react";
import { Activity, X, Users } from "lucide-react";

const EMOTION_META = {
  engaged:     { emoji: "🙂", color: "#00C8FF", label: "Engaged" },
  positive:    { emoji: "😄", color: "#00E5A3", label: "Positive" },
  neutral:     { emoji: "😐", color: "#7A93B4", label: "Neutral" },
  confused:    { emoji: "😕", color: "#FFB800", label: "Confused" },
  frustrated:  { emoji: "😠", color: "#FF4D6D", label: "Frustrated" },
  disengaged:  { emoji: "💤", color: "#7C5CFF", label: "Disengaged" },
};
// Server only reports low/medium/high — map to a bar fill rather than pretending precision it doesn't have.
const CONFIDENCE_PCT = { low: 35, medium: 65, high: 90 };

// Read from live speech every ~30s (see EMOTION_CHECK_INTERVAL_SECONDS on
// the backend) — a per-participant dashboard, not just a badge strip.
export default function EmotionsPanel({ emotions, onClose }) {
  const speakers = Object.keys(emotions);

  return (
    <>
      <div style={{ padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Activity size={14} color="#00C8FF" />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#E8F0FE" }}>Live Emotions</span>
        </div>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#7A93B4" }}><X size={15} /></button>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "16px 18px" }}>
        {speakers.length === 0 ? (
          <div style={{ textAlign: "center", color: "#3D5473", fontSize: 12.5, marginTop: 40 }}>
            <Users size={20} style={{ marginBottom: 8, opacity: 0.6 }} />
            <div>Reads each speaker's emotion from the live transcript every ~30s.</div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {speakers.map((name) => {
              const e = EMOTION_META[emotions[name]?.emotion] || EMOTION_META.neutral;
              const pct = CONFIDENCE_PCT[emotions[name]?.confidence] || 50;
              return (
                <div key={name} className="hm-line" style={{ background: "rgba(255,255,255,0.04)", border: `1px solid ${e.color}33`, borderRadius: 12, padding: "12px 14px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                    <span style={{ fontSize: 12.5, fontWeight: 700, color: "#E8F0FE" }}>{name}</span>
                    <span style={{ fontSize: 18 }}>{e.emoji}</span>
                  </div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: e.color, marginBottom: 6 }}>{e.label}</div>
                  <div style={{ height: 5, borderRadius: 3, background: "rgba(255,255,255,0.08)", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${pct}%`, borderRadius: 3, background: e.color, transition: "width 0.4s ease" }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ padding: "10px 18px", borderTop: "1px solid rgba(255,255,255,0.06)", fontSize: 10.5, color: "#3D5473", textAlign: "center" }}>
        Read from tone of speech — a signal, not a substitute for checking in directly
      </div>
    </>
  );
}
